import { render, staticRenderFns } from "./TeamCardByOlympic.vue?vue&type=template&id=27faa1c3&scoped=true"
import script from "./TeamCardByOlympic.vue?vue&type=script&lang=js"
export * from "./TeamCardByOlympic.vue?vue&type=script&lang=js"
import style0 from "./TeamCardByOlympic.vue?vue&type=style&index=0&id=27faa1c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27faa1c3",
  null
  
)

export default component.exports